import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    let active = true;
    const poll = async () => {
      if (!active) return;
      if (attempts.current >= 10) { setStatus("error"); return; }
      attempts.current += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          setTimeout(() => navigate(`/results/${res.data.attempt_id}`), 1200);
          return;
        }
        if (["expired", "failed"].includes(res.data.payment_status)) { setStatus("error"); return; }
      } catch (e) {
        // Transient status-check failure — keep polling until the attempt cap.
        console.error("Payment status check failed", e);
      }
      setTimeout(poll, 1800);
    };
    poll();
    return () => { active = false; };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0B0F17] flex flex-col items-center justify-center gap-5 px-5 text-center">
      {status === "checking" && (<>
        <Loader2 className="w-12 h-12 text-cyan-400 animate-spin" />
        <p className="text-slate-300 font-mono-data text-sm">Confirming your payment…</p>
      </>)}
      {status === "paid" && (<>
        <CheckCircle2 className="w-14 h-14 text-emerald-400" data-testid="payment-success-icon" />
        <p className="text-xl font-semibold text-white">Payment confirmed!</p>
        <p className="text-slate-400 text-sm">Unlocking your full report…</p>
      </>)}
      {status === "error" && (<>
        <XCircle className="w-14 h-14 text-rose-400" />
        <p className="text-xl font-semibold text-white">We couldn't confirm the payment</p>
        <button onClick={() => navigate("/history")} className="mt-2 px-5 py-2.5 rounded-xl bg-white/5 border border-white/10 text-slate-300 hover:bg-white/10">Go to history</button>
      </>)}
    </div>
  );
};
